import React, { useEffect, useRef, useState } from 'react';
import Header from '../../layouts/Header';
import { Button, Col, Row, Form, Table, Spinner, Pagination, Dropdown } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import makeAnimated from "react-select/animated";
import Select from "react-select";
import axios from '../../api/axios';
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';

const Category = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [menuAccess, setMenuAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("CategoryMgt:")
            );
            setMenuAccess(filteredAccess);
        } 
    }, [access]);
    
    console.log("Menu Access:", menuAccess);

    const accessToken = localStorage.getItem("authToken");
    const [inputData, setInputData] = useState({
        sequenceNumber: "",
        name: "",
        description: "",
        isEventCategory: "",
        orderType: "ALL"
    });
    const [searchText, setSearchText] = useState('');
    const [image, setImage] = useState(null);
    const [bannerImage, setBannerImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isDownloadLoading, setIsDownloadLoading] = useState(false);
    const [imageId, setImageId] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const animatedComponents = makeAnimated();
    const [outlets, setOutlets] = useState([]);
    const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
    const [editedSelectedExOutlets, setEditedSelectedExOutlets] = useState([]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [filteredData, setFilteredData] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [showBannerImageModal, setShowBannerImageModal] = useState(false);
    const [openImageUploadModal, setOpenImageUploadModal] = useState(false);
    const [openBannerImageUploadModal, setOpenBannerImageUploadModal] = useState(false);
    const [isImageEditBtnLoading, setIsImageEditBtnLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(10); // Adjust the rows per page as needed.
    const imageInputRef = useRef(null);

    const outletData = outlets.map((outlet) => ({
        value: outlet._id,
        label: `${outlet.name} (${outlet.city})`,
    }));

    // Calculate indices for slicing data
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    // Total pages calculation
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    // Handle page change
    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
    
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };
    
    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("outlet", { headers });
        
            if (response?.data?.status === true) {
                
                // let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");
                
                setOutlets(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
              let errorMessage = error.response.data.error;
              toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
              });
            }
        }
    };

    const getCategoryList = async (status) => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.get("masters/category/get", { headers });
    
          if (response?.data?.status === true) {
            response?.data?.data?.categories.forEach((item, index) => {
              item.serialNumber = index + 1;
            });
    
            setCategoryList(response?.data?.data?.categories);
            // setFilteredData(response?.data?.data?.categories);
            console.log("Category List :", response?.data?.data?.categories);
            let filteredCategoryList = response?.data?.data?.categories?.filter((cat) => cat?.status === status);
            console.log("Status :", status);
            
            if (status === "all" || status === undefined) {
              setFilteredData(response?.data?.data?.categories)
            } else {
              setFilteredData(filteredCategoryList)
            }
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    };

    const downloadCategoryReport = async () => {
        setIsDownloadLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            
            const response = await axios.get("masters/category/get", { 
                headers,
                params: { isDownload: true },
                responseType: 'blob' // Important for file download
            });

            // Create a blob from the response
            const blob = new Blob([response.data], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            
            // Create a download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            
            // Generate filename with current date and time
            const currentDate = new Date();
            const dateString = currentDate.toISOString().split('T')[0]; // YYYY-MM-DD
            const timeString = currentDate.toTimeString().split(' ')[0].replace(/:/g, '-'); // HH-MM-SS
            const fileName = `Category List.xlsx`;
            
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            toast.success("Category report downloaded successfully!", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        } catch (error) {
            console.error("Download error:", error);
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error || "Failed to download report";
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            } else {
                toast.error("Failed to download report. Please try again.", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDownloadLoading(false);
        }
    };

    const handleStatusFilter = (e) => {
        console.log("Hello :", e.target.value);
        let status = e.target.value;
        setSelectedStatus(status);
        getCategoryList(status);
    }

    const handleSelectChange = (selected) => {
        setSelectedExcludedOutlets(selected);
    }
    
    const handleEditSelectChange = (selected) => {
        setEditedSelectedExOutlets(selected);
    }

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    };

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        setBannerImage(null);
        setImage(null);
        setInputData({
            name: '',
            description: '',
            isEventCategory: '',
            sequenceNumber: ''
        })
        setSelectedExcludedOutlets([]);
    };

    const handleOpenEditModal = (data) => {
        console.log("edited Data :", data);
        setEditedData({
            id: data._id,
            name: data?.name,
            sequenceNumber: data?.sequenceNumber,
            description: data?.description,
            isEventCategory: data?.isEventCategory,
            status: data?.status,
            orderType: data?.orderType
        })
        let selectedExOutlet = data?.excludedOutletDetails;
        let mappedSelectedExOutlet = selectedExOutlet?.map((m) =>
            ({
                value: m?._id,
                label: m?.name
            }))
        setEditedSelectedExOutlets(mappedSelectedExOutlet);
        setOpenEditModal(true);

    }

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
    }

    const handleCloseImageModal = () => {
        setShowImageModal(false);
    };

    const handleImageUploadModal = (data) => {
        setImage(data?.displayImage);
        setImageId(data?._id);
        setOpenImageUploadModal(true);
        setShowImageModal(false);
    };

    const handleOpenDeleteModal = (data) => {
        setOpenDeleteModal(true);
        setCategoryId(data?._id);
    }

    const handleBannerImageUpload = (data) => {
        setOpenBannerImageUploadModal(true);
        setBannerImage(data?.bannerImage);
        setImageId(data?._id);
        setShowBannerImageModal(false);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputData((prevState) => ({ ...prevState, [name]: value }));
    };
    
    const handleImageChange = (e) => {
        const allowedExtensions = ["png", "jpg", "jpeg"];
        const selectedImage = e.target.files[0];
    
        if (selectedImage) {
          const extension = selectedImage.name.split(".").pop().toLowerCase();
          if (!allowedExtensions.includes(extension)) {
            toast.error("Invalid file format. Upload only jpg or png.", {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            return;
          } else {
            setImage(selectedImage);
          }
        }
    };
    
    const handleBannerImageChange = () => {
        const input = document.getElementById("imageInput");
    
        const file = input.files[0];
    
        if (file) {
          const reader = new FileReader();
    
            reader.onloadend = () => {
                const image = new Image();
                image.src = reader.result;
        
                image.onload = () => {
                const width = image.width;
                const height = image.height;
        
                const maxWidth = 1000;
                const maxHeight = 200;
        
                if (width === maxWidth && height === maxHeight) {
                    setBannerImage(file);
                } else {
                    alert(
                    "Image dimensions are not valid. Please choose an image with dimensions equal to " +
                    maxWidth +
                    "x" +
                    maxHeight
                    );
                    input.value = "";
                }
                };
            };
          reader.readAsDataURL(file);
        }
    };

    const handleBannerImageClick = (row) => {
        setSelectedImage(row);
        setShowBannerImageModal(true);
    };

    const handleImageClick = (row) => {
        setSelectedImage(row);
        setShowImageModal(true);
    };

    const handleEditBannerImage = () => {
        const file = imageInputRef?.current?.files[0];
        console.log("banner image file :", file);
    
        if (file) {
          const reader = new FileReader();
          setBannerImage(file);
    
          // reader.onloadend = () => {
          //   const image = new Image();
          //   image.src = reader.result;
    
          //   image.onload = () => {
          //     const width = image.width;
          //     const height = image.height;
    
          //     const maxWidth = 300;
          //     const maxHeight = 60;
    
          //     if (width === maxWidth && height === maxHeight) {
          //       setBannerImage(file);
          //     } else {
          //       alert(
          //         "Image dimensions are not valid. Please choose an image with dimensions equal to " +
          //         maxWidth +
          //         "x" +
          //         maxHeight
          //       );
          //       imageInputRef.current.value = "";
          //     }
          //   };
          // };
          reader.readAsDataURL(file);
        }
    };

    const handleEditImage = async (e) => {
        e.preventDefault();
        setIsImageEditBtnLoading(true);
        try {
            const formData = new FormData();
            formData.append("image", image);
            formData.append("id", imageId);
        
            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };
    
            const response = await axios.put(
                "masters/category/update-images",
                formData,
                { headers }
            );
    
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getCategoryList();
                setOpenImageUploadModal(false);
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error(error.response.data.error, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
                });
            }
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response?.data?.data?.message;
        
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
                });
            }
        } finally {
            setIsImageEditBtnLoading(false);
        }
    };

    const handleBannerEditImage = async (e) => {
        e.preventDefault();
        setIsImageEditBtnLoading(true);
        try {
          const formData = new FormData();
          formData.append("bannerImage", bannerImage);
          formData.append("id", imageId);
    
          const headers = {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          };
    
          const response = await axios.put(
            "masters/category/update-images",
            formData,
            { headers }
          );
    
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getCategoryList();
            setOpenBannerImageUploadModal(false);
          }
        } catch (error) {
          if (error.response.status === 404) {
            toast.error(error.response.data.error, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response?.data?.data?.message;
    
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsImageEditBtnLoading(false);
        }
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const addCategory = async (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        try {
          const formData = new FormData();
          console.log("SselectedExcludedOutlets :", selectedExcludedOutlets);
          
          let selectOutlets = selectedExcludedOutlets.map((val) => val?.value);
          console.log("Selected Outlets :", selectOutlets);
          
          let newInputData = {
            ...inputData,
            excludedOutlets: selectOutlets
          }
          formData.append("sequenceNumber", newInputData.sequenceNumber);
          formData.append("name", newInputData.name);
          formData.append("isEventCategory", newInputData.isEventCategory);
          formData.append("description", newInputData.description);
          formData.append("orderType", newInputData.orderType);
          formData.append("image", image);
          formData.append("bannerImage", bannerImage);
          // Convert array to JSON string
        //   if (selectOutlets?.length > 0 ) {
        //     formData.append("excludedOutlets", JSON.stringify(newInputData.excludedOutlets));
        //   }

          // Append each excluded outlet as excludedOutlets[0], excludedOutlets[1], etc.
        if (selectOutlets?.length > 0) {
            selectOutlets.forEach((outlet, index) => {
                formData.append(`excludedOutlets[${index}]`, outlet);
            });
        }
    
          const headers = {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          };
    
          const response = await axios.post("masters/category/add", formData, {
            headers,
          });
    
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getCategoryList();
            setSelectedExcludedOutlets([]);
            setInputData({
              name: "",
              description: "",
              isEventCategory: "",
              sequenceNumber: "",
              orderType: "ALL"
            });
            setImage(null);
            setBannerImage(null);
            setOpenAddModal(false);
          }
        } catch (error) {      
          if (error?.response) {
            let errorMessage = '';
            if ( error.response?.status === 406 ) {
              errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            }
            else if ( error.response?.status === 412 ) {
              errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
              errorMessage = error?.response?.data?.error
            }else if(error?.response?.status === 404) {
              errorMessage = error?.response?.data?.error
            }
    
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsLoading(false);
        }
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
      
        let updatedValue = value;
        if (name === "isComboCategory") {
          updatedValue = value === "true"; // Converts "true" to true and "false" to false
        }
      
        setEditedData((prevData) => ({
          ...prevData,
          [name]: updatedValue,
        }));
    };

    const editCategory = async (e) => {
        e.preventDefault();
        setIsEditLoading(true);
        try {
            const headers = {
              Authorization: `Bearer ${accessToken}`,
            };
            let selectedExOutlets = editedSelectedExOutlets?.map((ex) => ex?.value);
            let newEditedData = {
              ...editedData,
              excludedOutlets: selectedExOutlets
            }
      
            // if (selectedExOutlets?.length === 0 ) {
            //   delete newEditedData?.excludedOutlets
            // }
      
            const response = await axios.put("masters/category/update", newEditedData, {
              headers,
            });
            if (response?.data?.status === true) {
              toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
              });
              getCategoryList();
              setOpenEditModal(false);
            }
          } catch (error) {
            console.log("Error in Edit Category :", error);
            if (error?.response) {
              let errorMessage = '';
              if ( error.response?.status === 406 ) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
              } else if ( error.response?.status === 403 ) {
                errorMessage = error?.response?.data?.data?.message;
              } else if ( error.response?.status === 412 ) {
                errorMessage = error?.response?.data?.data?.message;
              } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error
              }
      
              toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
              });
            }
          } finally {
            setIsEditLoading(false);
          }
    };

    const deleteCategory = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.delete(
                `masters/category/delete?id=${categoryId}`,
                { headers }
            );
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getCategoryList();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            // if (error.response.status === 403) {
            //     toast.error(error?.response?.data?.message, {
            //     position: "top-right",
            //     autoClose: 3000,
            //     theme: "colored",
            //     });
            // }

            // if (error.response && error.response?.data?.status === false) {
            //     let errorMessage = error.response.data.error;
            //     toast.error(errorMessage, {
            //     position: "top-right",
            //     autoClose: 3000,
            //     theme: "colored",
            //     });
            // }
            console.log("Error in Delete :", error);
            
            let errorMessage = "";

            if ( error.response?.status === 406 ) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            } else if ( error.response?.status === 403 ) {
                errorMessage = error?.response?.data?.message;
            } else if ( error.response?.status === 412 ) {
                errorMessage = error?.response?.data?.message;
            } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error
            }
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } finally {
            setIsDeleteLoading(false);
        }
    }

    useEffect(() => {
        getOutlets();
        getCategoryList();
    }, []);

    useEffect(() => {
        const result = categoryList.filter((item) => {
          return (
            item.name.toLowerCase().match(searchText.toLocaleLowerCase()) ||
            item.description.toLowerCase().match(searchText.toLocaleLowerCase())
          );
        });
        setFilteredData(result);
    }, [searchText]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className='container' style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                    <Row>
                        <Col className='text-center'>
                            <h5 className='fw-bold text-muted' style={{ textDecoration: 'underline' }}>CATEGORY MANAGEMENT</h5>
                        </Col>
                    </Row>
                    {/* Row for Filters and Add Button */}
                    <Row className="justify-content-between align-items-center">
                        <Col lg='2'>
                            <Form.Label className="fw-semibold">Select Status</Form.Label>
                            <Form.Select aria-label="Default select example" onChange={handleStatusFilter} value={selectedStatus}>
                                <option value="all">Status</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </Form.Select>
                        </Col>
                        <Col lg="4" className="d-flex flex-column">
                            <Form.Label className='text-white'>.</Form.Label>
                            <div className="form-search me-auto w-100">
                                <input type="text" className="form-control" value={searchText} onChange={handleSearchChange} placeholder="Search By Category Name" />
                                <i className="ri-search-line"></i>
                            </div>
                        </Col>
                        <Col lg="3" className="d-flex justify-content-end flex-column">
                            <Form.Label className='text-white'>.</Form.Label>
                            <Button
                                variant="success"
                                onClick={downloadCategoryReport}
                                className="fw-semibold"
                                disabled={isDownloadLoading}
                            >
                                {isDownloadLoading ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-2"
                                        />
                                        Downloading...
                                    </>
                                ) : (
                                    <>
                                        <i className="ri-download-line" style={{ marginRight: '5px' }}></i>
                                        Download Report
                                    </>
                                )}
                            </Button>
                        </Col>
                        {(menuAccess.includes("CategoryMgt:add") || email === "contact@xpansecafe.com") && (
                            <Col lg="3" className="d-flex justify-content-end flex-column">
                                <Form.Label className='text-white'>.</Form.Label>
                                <Button
                                    variant="primary"
                                    onClick={handleOpenAddModal}
                                    className="fw-semibold"
                                >
                                    <i className="ri-add-line" style={{ marginRight: '5px' }}></i>
                                    Add New Category
                                </Button>
                            </Col>
                        )}
                    </Row>

                    {/* <-------------- Table - List of catgeories ---------> */}
                    <Row className="mt-4">
                        <Col>
                            {(menuAccess.includes("CategoryMgt:get") || email === "contact@xpansecafe.com") && (
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Banner Image</th>
                                            <th>Image</th>
                                            <th>Seq No</th>
                                            <th>Name</th>
                                            <th>Status & Order Type</th>
                                            <th>Description</th>
                                            {((menuAccess.includes("CategoryMgt:update") || menuAccess.includes("CategoryMgt:delete")) || email === "contact@xpansecafe.com") && (
                                            <th>Action</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { paginatedData?.map((cat, index) => ( 
                                                <tr className='align-items-center' style={{ verticalAlign: 'middle' }}>
                                                    <td>{cat?.serialNumber ? cat.serialNumber : "--------"}</td>
                                                    <td className='align-items-center' style={{ width: '250px' }}>
                                                        <img
                                                            src={cat?.bannerImage}
                                                            alt="Banner"
                                                            className="img-fluid"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                marginTop: "8px",
                                                                marginBottom: '8px',
                                                                border: "0.2px solid bluevoilet",
                                                                cursor: "pointer",
                                                                // marginRight: 
                                                            }}
                                                            onClick={() => handleBannerImageClick(cat)}
                                                        />
                                                    </td>
                                                    <td className='text-center'>
                                                        <img
                                                            src={cat?.displayImage}
                                                            alt="Image"
                                                            className="img-fluid"
                                                            style={{
                                                                width: "95px",
                                                                height: "95px",
                                                                borderRadius: "50%",
                                                                marginTop: "8px",
                                                                marginBottom: "8px",
                                                                border: "0.2px solid bluevoilet",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleImageClick(cat)}
                                                        />
                                                    </td>
                                                    <td>{cat?.sequenceNumber}</td>
                                                    <td style={{ width: '160px' }}>
                                                        <span className='fw-semibold'>{cat?.name}</span> 
                                                        <br />
                                                        <span style={{ color: cat.isEventCategory === true ? "chocolate" : "teal" }}>{cat?.isEventCategory === true ? "Event Outlet" : "Regular Outlet"}</span>
                                                    </td>
                                                    <td>
                                                        {cat?.status ? (
                                                            <span
                                                                className={`badge ${
                                                                    cat.status === "ACTIVE"
                                                                        ? "bg-success"
                                                                        : cat.status === "INACTIVE"
                                                                        ? "bg-danger"
                                                                        : "bg-secondary"
                                                                } w-100 fw-semibold`}
                                                                style={{ borderRadius: '18px' }}
                                                            >
                                                                {cat?.status}
                                                            </span>
                                                        ) : (
                                                            "------"
                                                        )}
                                                        <div className='text-center mt-1 fw-semibold' style={{ color: cat?.orderType === "PICKUP" ? 'blueviolet' : cat?.orderType === "DELIVERY" ? 'green' : 'orangered' }}>{cat?.orderType ? cat?.orderType : 'ALL'}</div>
                                                    </td>
                                                    <td style={{ width: '250px', fontSize: '12px' }}>
                                                        <span className='fw-semibold' style={{ color: 'purple' }}>Excluded Outlets : {cat?.excludedOutletDetails && cat?.excludedOutletDetails?.length > 0
                                                            ? cat?.excludedOutletDetails.map(outlet => outlet?.name?.toLowerCase().trim()).join(', ')
                                                            : "No outlets excluded"}
                                                        </span> <br />
                                                        <span className='text-secondary'>{cat?.description}</span>
                                                    </td>
                                                    {((menuAccess.includes("CategoryMgt:update") || menuAccess.includes("CategoryMgt:delete")) || email === "contact@xpansecafe.com") && (
                                                        <td style={{ width: '140px' }}>
                                                            <div className="d-flex justify-content-center">
                                                                <Dropdown>
                                                                    <Dropdown.Toggle size="sm" variant="primary" id="dropdown-basic">
                                                                        Actions
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        {(menuAccess.includes("CategoryMgt:update") || email === "contact@xpansecafe.com") && (
                                                                            <Dropdown.Item onClick={() => handleOpenEditModal(cat)} className='text-success'>Edit</Dropdown.Item>
                                                                        )}
                                                                        {(menuAccess.includes("CategoryMgt:delete") || email === "contact@xpansecafe.com") && (
                                                                            <Dropdown.Item onClick={() => handleOpenDeleteModal(cat)} className="text-danger">
                                                                                Delete
                                                                            </Dropdown.Item>
                                                                        )}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                            )
                                        ) }
                                    </tbody>
                                </Table>
                            )}
                            <Pagination className="justify-content-center">
                                {[...Array(totalPages).keys()].map((page) => (
                                    <Pagination.Item
                                    key={page + 1}
                                    active={page + 1 === currentPage}
                                    onClick={() => handlePageChange(page + 1)}
                                    >
                                    {page + 1}
                                    </Pagination.Item>
                                ))}
                            </Pagination>
                        </Col>
                    </Row>
                </div>

                {/* <---------------- Add New Category Modal ------------> */}
                <Modal show={openAddModal} onHide={handleCloseAddModal} size='lg' centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Add New Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label>Category Name <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="name"
                                            className="form-control"
                                            value={inputData.name}
                                            type="text"
                                            placeholder="Enter Name of the Category"
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label>Seq No. <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name='sequenceNumber'
                                            className="form-control"
                                            value={inputData?.sequenceNumber}
                                            type="number"
                                            onChange={handleChange}
                                            placeholder="Enter Sequence Number"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Label>Speicfy Outlet Type <span className="text-danger">*</span></Form.Label>
                                    <Form.Select className='form-control' aria-label="Default select example" name="isEventCategory" value={inputData?.isEventCategory} onChange={handleChange}>
                                        <option value="">Select Role</option>
                                        <option value="false">For Regular Outlet</option>
                                        <option value="true">For Event Outlet</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <Form.Group>
                                    <Form.Label>
                                        Order Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="orderType"
                                        value={inputData.orderType || ""}
                                        onChange={handleChange}
                                    >
                                        <option value="ALL">ALL</option>
                                        <option value="DELIVERY">DELIVERY</option>
                                        <option value="PICKUP">PICK-UP</option>
                                    </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Label>Excluded Outlets</Form.Label>
                                    <Select
                                        isMulti
                                        components={animatedComponents}
                                        value={selectedExcludedOutlets}
                                        onChange={handleSelectChange}
                                        options={outletData}
                                        styles={customStyles}
                                        placeholder="Select Excluded Outlets" // You can also use a dynamic placeholder from props or state
                                        closeMenuOnSelect={false}
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 0,
                                            colors: {
                                                ...theme.colors,
                                                primary25: "#e9ecef",
                                                primary: "#007bff",
                                            },
                                        })}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group controlId="formCategoryDescription">
                                        <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            name='description'
                                            value={inputData.description}
                                            rows={3}
                                            className="form-control"
                                            placeholder="Enter category description"
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col>
                                    <Form.Label>Choose Banner Image <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type='file'
                                        id='imageInput'
                                        accept='image/*'
                                        placeholder="Choose Banner Image"
                                        className="form-control"
                                        onChange={handleBannerImageChange}
                                    />
                                    <span className="text-danger mt-3" style={{ fontSize: '11px' }}>Choose an image with dimensions equal to 1000x200</span>
                                </Col>
                                <Col>
                                    <Form.Label>Choose Image <span className="text-danger">*</span></Form.Label>
                                    <Form.Control 
                                        type="file"
                                        onChange={handleImageChange}
                                        className="form-control"
                                        id="formFile"
                                        placeholder='Choose Category Image'
                                        accept="image/*"
                                    />
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={addCategory}>
                            { isLoading ?
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /> :
                                "Add Category"                                
                            }
                        </Button>
                        <Button variant="secondary" onClick={handleCloseAddModal}>
                            Close
                        </Button>
                        
                    </Modal.Footer>
                </Modal>

                {/* <---------------- Edit Category Modal ------------> */}
                <Modal show={openEditModal} onHide={handleCloseEditModal} size='lg' centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Update Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row className="mb-3">
                                <Col md="3">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label>Category Name <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            name="name"
                                            className="form-control"
                                            value={editedData?.name}
                                            type="text"
                                            placeholder="Enter Name of the Category"
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md="3">
                                    <Form.Group controlId="formCategoryName">
                                        <Form.Label>Seq No. <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            name='sequenceNumber'
                                            className="form-control"
                                            value={editedData?.sequenceNumber}
                                            type="number"
                                            onChange={handleEditChange}
                                            placeholder="Enter Sequence Number"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md="3">
                                    <Form.Label>Specify Outlet Type <span className='text-danger'>*</span></Form.Label>
                                    <Form.Select className='form-control' aria-label="Default select example" name="isEventCategory" value={editedData?.isEventCategory} onChange={handleEditChange}>
                                        <option value="">Select Role</option>
                                        <option value="false">For Regular Outlet</option>
                                        <option value="true">For Event Outlet</option>
                                    </Form.Select>
                                </Col>
                                <Col md="3">
                                    <Form.Label>Status <span className='text-danger'>*</span></Form.Label>
                                    <Form.Select className='form-control' aria-label="Default select example" name="status" value={editedData?.status} onChange={handleEditChange}>
                                        <option value="">Select status</option>
                                        <option value="ACTIVE">Active</option>
                                        <option value="INACTIVE">Inactive</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>
                                            Order Type <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            name="orderType"
                                            value={editedData.orderType || ""}
                                            onChange={handleEditChange}
                                        >
                                            <option value="" disabled>Select</option>
                                            <option value="ALL">ALL</option>
                                            <option value="DELIVERY">DELIVERY</option>
                                            <option value="PICKUP">PICK-UP</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md="3">
                                    <Form.Label>Combo Category <span className='text-danger'>*</span></Form.Label>
                                    <Form.Select className='form-control' aria-label="Default select example" name="isComboCategory" value={editedData?.isComboCategory} onChange={handleEditChange}>
                                        <option value="">Select</option>
                                        <option value="true">YES</option>
                                        <option value="false">NO</option>
                                    </Form.Select>
                                </Col>
                                <Col md="6">
                                    <Form.Label>Excluded Outlets</Form.Label>
                                    <Select
                                        isMulti
                                        components={animatedComponents}
                                        value={editedSelectedExOutlets}
                                        onChange={handleEditSelectChange}
                                        options={outletData}
                                        styles={customStyles}
                                        placeholder="Select Excluded Outlets" // You can also use a dynamic placeholder from props or state
                                        closeMenuOnSelect={false}
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 0,
                                            colors: {
                                                ...theme.colors,
                                                primary25: "#e9ecef",
                                                primary: "#007bff",
                                            },
                                        })}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group controlId="formCategoryDescription">
                                        <Form.Label>Description <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            name='description'
                                            value={editedData.description}
                                            rows={3}
                                            className="form-control"
                                            placeholder="Enter category description"
                                            onChange={handleEditChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={editCategory}>
                            { isEditLoading ?
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /> :
                                "Save Changes"                                
                            }
                        </Button>
                        <Button variant="secondary" onClick={handleCloseEditModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* <---------------- Delete Category Modal ------------> */}
                <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this category? This action cannot be undone.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeleteModal}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={deleteCategory}>
                            { isDeleteLoading ?
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /> :
                                "Delete Category"                                
                            }
                        </Button>
                    </Modal.Footer>
                </Modal>

                {showImageModal && (
                    <Modal show={showImageModal} onHide={handleCloseImageModal}>
                        <Modal.Header closeButton style={{ backgroundColor: "#F5F5F5" }}>
                            <Modal.Title>Image Preview</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedImage ? (
                                <div className='d-flex flex-column'>
                                    <img
                                        src={selectedImage?.displayImage}
                                        alt="preview"
                                        style={{ width: "50%", height: "auto", alignSelf: 'center' }}
                                    />
                                    <Button
                                        className="mt-4 w-50"
                                        variant="primary"
                                        onClick={() =>
                                            handleImageUploadModal({
                                            displayImage: selectedImage?.displayImage,
                                            _id: selectedImage?._id,
                                            })
                                        }
                                    >
                                        Change Image
                                    </Button>
                                </div>
                            ) : (
                                <>
                                    <p>No Image Profile. Upload a Picture.</p>
                                    <button className="btn btn-primary rounded-pill mt-2">
                                        Upload Image
                                    </button>
                                </>
                            )}
                        </Modal.Body>
                    </Modal>
                )}

                {showBannerImageModal && (
                    <Modal
                        show={showBannerImageModal}
                        onHide={() => setShowBannerImageModal(false)}
                    >
                        <Modal.Header closeButton style={{ backgroundColor: "#F5F5F5" }}>
                            <Modal.Title>Banner Image Preview</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedImage ? (
                            <>
                                <img
                                src={selectedImage?.bannerImage}
                                alt="preview"
                                style={{ width: "100%", height: "auto" }}
                                />
                                <Button
                                    className="mt-3"
                                    variant="primary"
                                    onClick={() =>
                                            handleBannerImageUpload({
                                            bannerImage: selectedImage?.bannerImage,
                                            _id: selectedImage?._id,
                                        })
                                    }
                                >
                                    Change Image
                                </Button>
                            </>
                            ) : (
                            <>
                                <p>No Image Profile. Upload a Picture.</p>
                                <button className="btn btn-primary rounded-pill mt-2">
                                    Upload Image
                                </button>
                            </>
                            )}
                        </Modal.Body>
                    </Modal>
                )}

                {openBannerImageUploadModal ? (
                    <Modal
                        show={openBannerImageUploadModal}
                        onHide={() => setOpenBannerImageUploadModal(false)}
                    >
                        <Modal.Header closeButton style={{ backgroundColor: "#F5F5F5" }}>
                            <Modal.Title>UPDATE BANNER IMAGE</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group>
                                <Form.Label className='fw-semibold'>Choose File</Form.Label>
                                <Form.Control
                                    type='file'
                                    id='imageInput'
                                    accept='image/*'
                                    placeholder="Choose Banner Image"
                                    className="form-control"
                                    onChange={handleEditBannerImage}
                                    ref={imageInputRef}
                                />
                                <span className="text-danger mt-3" style={{ fontSize: '11px' }}>Choose an image with dimensions equal to 1000x200</span>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant='primary' onClick={handleBannerEditImage}>
                                { isImageEditBtnLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    "Save Changes"                                
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal> ) 
                : null }

                {openImageUploadModal ? (
                    <Modal
                        show={openImageUploadModal}
                        onHide={() => setOpenImageUploadModal(false)}
                    >
                        <Modal.Header closeButton style={{ backgroundColor: "#F5F5F5" }}>
                            <Modal.Title>UPDATE  IMAGE</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group>
                                <Form.Label className='fw-semibold'>Choose File</Form.Label>
                                <Form.Control
                                    type='file'
                                    id='imageInput'
                                    accept='image/*'
                                    placeholder="Choose Banner Image"
                                    className="form-control"
                                    onChange={handleImageChange}
                                />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant='primary' onClick={handleEditImage}>
                                { isImageEditBtnLoading ?
                                    <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    /> :
                                    "Save Changes"                                
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal>
                ) : null}
            </div>
        </React.Fragment>
    );
};

export default Category;